import * as actionTypes from './actionTypes';

// Init state
export const mainState = {
  isLoading: true,
  isLoadingTable: false,
  isLoadingPagination: false,
  updateList: false,
  isInitPage: false,
  initPageError: null,

  filters: {
    query: null,
    search_type: null,
    status: null,
    delay: null,
    service: null,
  },
  pagination: null,
  tasks: [],
  statuses: [],
  checked: [],
  modal: null,
  configuration: null,
  modes: {
    isLoading: false,
    data: [],
  },
  services: {
    isLoading: false,
    data: [],
  },
};

export const mainReducer = (state, action) => {
  const { payload } = action;
  switch (action.type) {
  case actionTypes.MAIN_LOADING_TABLE:
    return {
      ...state,
      isLoadingTable: true,
    };
  case actionTypes.MAIN_LIST_UPDATE:
    return {
      ...state,
      isLoadingTable: true,
      updateList: true,
    };
  case actionTypes.MAIN_LIST_UPDATE_SUCCESS:
    return {
      ...state,
      checked: [],
      isLoadingTable: false,
      updateList: false,
      isLoadingPagination: false,
      pagination: payload.pagination,
      tasks: payload.tasks,
      filters: payload.filters,
    };
  case actionTypes.MAIN_LIST_UPDATE_ERROR:
    return {
      ...state,
      isLoadingTable: false,
      isInitPage: true,
      isLoadingPagination: false,
      initPageError: {
        data: payload.data,
        status: payload.status,
        statusText: payload.statusText,
      },
    };
  case actionTypes.MAIN_LIST_SUCCESS:
    return {
      ...state,
      isInitPage: true,
      initPageError: null,
      isLoadingTable: false,
      isLoadingPagination: false,
      search_types: payload.search_types,
      pagination: payload.pagination,
      configuration: payload.configuration,
      tasks: payload.tasks,
      statuses: payload.statuses.map((status) => {
        if (status.id === 1) {
          return {
            ...status,
          };
        }
        return {
          ...status,
          count: 0,
        };
      }),
      filters: payload.filters,
      sort: payload.sort,
      modes: {
        ...state.modes,
        data: payload.modes,
      },
      services: {
        ...state.services,
        data: payload.services.map((service) => {
          const { id, title, visibility } = service;
          return {
            id,
            label: title,
            visibility,
          };
        }),
      },
    };
  case actionTypes.MAIN_PAGINATION_UPDATE:
    return {
      ...state,
      isLoadingPagination: true,
    };
  case actionTypes.MAIN_PAGINATION_UPDATE_SUCCESS:
    return {
      ...state,
      pagination: payload,
      isLoadingPagination: false,
    };
  case actionTypes.MAIN_GET_MODES_FILTER:
    return {
      ...state,
      delays: {
        ...state.delays,
        isLoading: true,
      },
    };
  case actionTypes.MAIN_GET_MODES_FILTER_SUCCESS:
    return {
      ...state,
      modes: {
        ...state.modes,
        isLoading: false,
        data: payload.data,
      },
    };
  case actionTypes.MAIN_GET_MODES_FILTER_ERROR:
    return {
      ...state,
      modes: {
        ...state.modes,
        isLoading: false,
      },
    };
  case actionTypes.MAIN_GET_MODES_FILTER_CLEAR:
    return {
      ...state,
      modes: {
        ...state.modes,
        data: [],
      },
    };
  case actionTypes.MAIN_GET_SERVICE_FILTER:
    return {
      ...state,
      services: {
        ...state.services,
        isLoading: true,
      },
    };
  case actionTypes.MAIN_GET_SERVICE_FILTER_SUCCESS:
    return {
      ...state,
      services: {
        ...state.services,
        isLoading: false,
        data: payload.data,
      },
    };
  case actionTypes.MAIN_GET_SERVICE_FILTER_ERROR:
    return {
      ...state,
      service: {
        ...state.service,
        isLoading: false,
      },
    };
  case actionTypes.MAIN_CHANGE_STATUS_SUCCESS:
    return {
      ...state,
      isLoadingTable: true,
      updateList: true,
      modal: null,
    };
  case actionTypes.MAIN_CHANGE_MASS_STATUS_SUCCESS:
    return {
      ...state,
      isLoadingTable: true,
      updateList: true,
      modal: null,
      checked: [],
    };
  case actionTypes.MAIN_MODAL_OPEN:
    return {
      ...state,
      modal: {
        name: payload.name,
        data: payload.data,
      },
    };
  case actionTypes.MAIN_MODAL_CLOSE:
    return {
      ...state,
      modal: null,
    };
  case actionTypes.MAIN_CHECKED:
    return {
      ...state,
      checked: payload.checked,
    };
  default:
    throw new Error();
  }
};

// Action creator
export function listSuccess(payload) {
  return { type: actionTypes.MAIN_LIST_SUCCESS, payload };
}

export function loadingTable() {
  return { type: actionTypes.MAIN_LOADING_TABLE };
}

export function loadingTablePagination() {
  return { type: actionTypes.MAIN_PAGINATION_UPDATE };
}

export function updateListSuccess(payload) {
  return { type: actionTypes.MAIN_LIST_UPDATE_SUCCESS, payload };
}

export function updatePaginationSuccess(payload) {
  return { type: actionTypes.MAIN_PAGINATION_UPDATE_SUCCESS, payload };
}

export function updateListError(data, status, statusText) {
  return {
    type: actionTypes.MAIN_LIST_UPDATE_ERROR,
    payload: {
      data,
      status,
      statusText,
    },
  };
}

export function getModesFilter() {
  return { type: actionTypes.MAIN_GET_MODES_FILTER };
}
export function getModesFilterSuccess(data) {
  return { type: actionTypes.MAIN_GET_MODES_FILTER_SUCCESS, payload: { data } };
}
export function getModesFilterError() {
  return { type: actionTypes.MAIN_GET_MODES_FILTER_ERROR };
}
export function getServiceFilter() {
  return { type: actionTypes.MAIN_GET_SERVICE_FILTER };
}
export function getServiceFilterSuccess(data) {
  return { type: actionTypes.MAIN_GET_SERVICE_FILTER_SUCCESS, payload: { data } };
}
export function getServiceFilterError() {
  return { type: actionTypes.MAIN_GET_SERVICE_FILTER_ERROR };
}

export function modalClose() {
  return { type: actionTypes.MAIN_MODAL_CLOSE };
}

export function modalOpen(name, data) {
  return { type: actionTypes.MAIN_MODAL_OPEN, payload: { name, data } };
}

export function changeStatusSuccess() {
  return { type: actionTypes.MAIN_CHANGE_STATUS_SUCCESS };
}

export function changeMassStatusSuccess() {
  return { type: actionTypes.MAIN_CHANGE_MASS_STATUS_SUCCESS };
}

export function changeChecked(checked) {
  return { type: actionTypes.MAIN_CHECKED, payload: { checked } };
}
